import { useRef, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import * as S from './styles';
import * as Base from '../styles';
import TextInput from 'components/Widget/Input/TextInput';
import useOnClickOutside from 'hooks/useOnClickOutside';

interface ColorInputProps {
	color: string; // of form #FF0000
	onColorChange?: (color: string) => void;
}

const ColorInput = ({ color, onColorChange }: ColorInputProps) => {
	const colorInput = useRef(null);

	const [isOpen, setOpen] = useState(false);
	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------
	const onChangeColor = (color: string) => {
		onColorChange?.(color);
	};

	const open = () => {
		setOpen(true);
	};

	const close = () => {
		setOpen(false);
	};

	useOnClickOutside(colorInput, close);

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	return (
		<Base.Base>
			<S.ColorSection>
				<S.Swatch color={color} onClick={open} />
				{isOpen && (
					<S.ColorInput ref={colorInput}>
						<HexColorPicker color={color} onChange={onChangeColor} />
						<TextInput value={color} onChange={(e) => onChangeColor(e.target.value)} />
					</S.ColorInput>
				)}
			</S.ColorSection>
			<TextInput value={color} onChange={(e) => onChangeColor(e.target.value)} />
		</Base.Base>
	);
};

export default ColorInput;
